<template>
  <div class="custom-tree">
    <custom-tree-group :data="data" :change="onChange" :isRoot="true" @deletechildren="deleteChildren" v-if="isUpdateFilter"></custom-tree-group>
  </div>
</template>

<script>
import customTreeGroup from './group';
import isNil from 'lodash/isNil';
import isEqual from "lodash/isEqual";
export default {
  name: 'customTree',
  props: ['conditionList', 'optionMap', 'data'],
  provide() {
    return {
      optionMap: this.optionMap, // testData.optionMap, //this.optionMap,
      conditionList: this.conditionList,// testData.conditionList//this.conditionList
      register: this.register
    }
  },
  components: {
    customTreeGroup,
  },
  data() {
    return {
      children: [],
      isUpdateFilter: true,//是否更新渲染筛选项
    }
  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        if (!isEqual(newVal, oldVal)) {
          this.isUpdateFilter = false
          this.children = []
          setTimeout(() => {
            this.isUpdateFilter = true
            this.setItem('session', 'isChangeTemplate', false)//重新渲染dom时重置模板改变的状态
          }, 0)
        }
      },
      deep: true
    }
  },

  methods: {
    //  ??
    // getConditions() {
    //   // 获取搜索条件
    //   return this.data;
    // },
    validator() {
      // 校验条件是否合法，返回 true 或 false ，并自动定位错误条件并显示错误信息
      let flag = true;
      this.children.forEach(item => {
        // let result= item.validator();
        let result = item.validateNode();
        if (!result) {
          flag = false;
        }
      })
      return flag;
    },

    register(node) {
      this.children.push(node);
    },

    onChange() {

    },
    deleteChildren(index) {
      const firstIndex = this.children.findIndex(item => item.data.id == index);
      this.children.splice(firstIndex, 1);
    }
  },
}
</script>

<style lang="scss" scoped>
.custom-tree {
  padding: 24px 0 24px 24px;
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: #595959;
}
</style>



// WEBPACK FOOTER //
// src/components/customTree/tree.vue